export function parseSettingValue(setting, fallback) {
    if (!setting) return fallback;

    try {
        return JSON.parse(setting.settingValueJson);
    } catch {
        return fallback;
    }
}

export function getSetting(settings, key, fallback) {
    const match = (settings || []).find(x => x.settingKey === key);
    return parseSettingValue(match, fallback);
}

export function toSettingPayload(key, value, valueType = "string") {
    return {
        scope: "global",
        settingKey: key,
        settingValueJson: JSON.stringify(value),
        valueType,
        isSecret: false,
        isSystem: false
    };
}